/**
 * DOC-3 — Riverside NF demo seed.
 *
 * Two loads:
 *   KLD-20418 — domestic, Romeoville IL → Austin TX, 38,200 lbs almond butter
 *   KLD-20417 — international, Romeoville IL → Toronto ON, frozen berries
 *
 * Each has 8-16 wms_picks rows for realistic packing-list generation.
 */

const NOW = '2026-04-18T10:30:00Z';

export const SEED_RIVERSIDE_LOADS = [
  {
    id: 'KLD-20418',
    loadNumber: 'KLD-20418',
    status: 'tendered',
    mode: 'FTL',
    equipmentType: 'Reefer',
    customerName: 'Riverside Natural Foods',
    customerId: 'cust-riverside-nf',
    shipperName: 'Riverside Natural Foods',
    shipperAddress: '890 Industrial Pkwy, Romeoville IL 60446',
    consigneeName: 'Whole Foods DC 2154',
    consigneeAddress: '4201 Centerpoint Dr, Austin TX 78758',
    origin: { city: 'Romeoville', state: 'IL', address: '890 Industrial Pkwy, Romeoville IL 60446' },
    destination: { city: 'Austin', state: 'TX', address: '4201 Centerpoint Dr, Austin TX 78758' },
    weightLbs: 38200, pallets: 24,
    commodity: 'Organic almond butter (FAK)', freightClass: 70,
    bolNumber: 'RVN-44928-BOL', referenceNumber: 'RVN-44928',
    pickupAt: '2026-04-19T08:00:00Z',
    deliveryAt: '2026-04-22T14:00:00Z',
    specialInstructions: 'Reefer 34°F continuous; lift gate at delivery; consignee hours 07:00-15:00.',
    international: false,
    carrierName: 'Bluebird Trucking',
    carrierScac: 'BBTK',
    carrierContact: { name: 'Jen Arias', email: 'dispatch@bluebirdtrucking.example' },
    brokerContact:  { name: 'Marcus Hill', email: 'mhill@kairos-brokerage.example' },
    financials: { customerRate: 4280, carrierCost: 3650, marginPercent: 14.7 },
    createdAt: '2026-04-18T07:14:00Z',
  },
  {
    id: 'KLD-20417',
    loadNumber: 'KLD-20417',
    status: 'tendered',
    mode: 'FTL',
    equipmentType: 'Reefer',
    customerName: 'Riverside Natural Foods',
    customerId: 'cust-riverside-nf',
    shipperName: 'Riverside Natural Foods',
    shipperAddress: '890 Industrial Pkwy, Romeoville IL 60446',
    consigneeName: 'Sobeys National DC',
    consigneeAddress: '4590 Steeles Ave E, Toronto ON M2H 3P6',
    origin: { city: 'Romeoville', state: 'IL', address: '890 Industrial Pkwy, Romeoville IL 60446' },
    destination: { city: 'Toronto', state: 'ON', address: '4590 Steeles Ave E, Toronto ON M2H 3P6' },
    weightLbs: 32100, pallets: 20,
    commodity: 'Organic frozen berries — mixed',
    freightClass: 60,
    bolNumber: 'RVN-44911-BOL', referenceNumber: 'RVN-44911',
    pickupAt: '2026-04-19T09:00:00Z',
    deliveryAt: '2026-04-23T11:00:00Z',
    specialInstructions: 'Frozen -10°F continuous; CARM + PARS docs required at border.',
    international: true,
    countryOfOrigin: 'US',
    incoterms: 'DDP',
    hsCode: '08119090',
    carrierName: 'Northern Cross Logistics',
    carrierScac: 'NXCL',
    carrierContact: { name: 'Priya Iyer', email: 'ops@northerncross.example' },
    brokerContact:  { name: 'Janelle Oduya', email: 'joduya@kairos-brokerage.example' },
    financials: { customerRate: 5920, carrierCost: 4980, marginPercent: 15.9 },
    createdAt: NOW,
  },
];

// wms_picks rows — 8-16 per load with realistic SKU / lot / qty / weight
export const SEED_RIVERSIDE_PICKS = [
  // KLD-20418 — 14 picks
  ...seedPicksFor('KLD-20418', [
    { sku: 'RNF-AB-16',  description: 'Organic almond butter 16oz',     qty: 360, weightLbs: 2880, pallets: 2, lot: 'L2604A' },
    { sku: 'RNF-AB-32',  description: 'Organic almond butter 32oz',     qty: 240, weightLbs: 3840, pallets: 2, lot: 'L2604B' },
    { sku: 'RNF-AB-64',  description: 'Organic almond butter 64oz',     qty: 180, weightLbs: 5400, pallets: 3, lot: 'L2604C' },
    { sku: 'RNF-AB-CAS', description: 'Almond butter food service 5gal', qty: 48,  weightLbs: 3120, pallets: 2, lot: 'L2604D' },
    { sku: 'RNF-CB-16',  description: 'Cashew butter 16oz',             qty: 180, weightLbs: 1800, pallets: 1, lot: 'L2604E' },
    { sku: 'RNF-SB-16',  description: 'Sunbutter 16oz',                 qty: 220, weightLbs: 2200, pallets: 2, lot: 'L2604F' },
    { sku: 'RNF-TA-16',  description: 'Tahini 16oz',                    qty: 160, weightLbs: 1600, pallets: 1, lot: 'L2604G' },
    { sku: 'RNF-HZ-16',  description: 'Hazelnut butter 16oz',           qty: 120, weightLbs: 1200, pallets: 1, lot: 'L2604H' },
    { sku: 'RNF-PK-12',  description: 'Pecan butter 12oz',              qty: 140, weightLbs: 1260, pallets: 1, lot: 'L2604I' },
    { sku: 'RNF-MX-16',  description: 'Mixed nut butter 16oz',          qty: 100, weightLbs: 1000, pallets: 1, lot: 'L2604J' },
    { sku: 'RNF-ABS-16', description: 'Almond butter stick packs 16ct', qty: 160, weightLbs: 640,  pallets: 1, lot: 'L2604K' },
    { sku: 'RNF-GIFT',   description: 'Gift sampler 4-pack',             qty: 80,  weightLbs: 640,  pallets: 1, lot: 'L2604L' },
    { sku: 'RNF-SVC',    description: 'Service kits (jars/labels)',     qty: 120, weightLbs: 360,  pallets: 1, lot: 'L2604M' },
    { sku: 'RNF-POS',    description: 'POS displays',                   qty: 60,  weightLbs: 540,  pallets: 1, lot: 'L2604N' },
  ]),
  // KLD-20417 — 10 picks
  ...seedPicksFor('KLD-20417', [
    { sku: 'RNF-FB-BB',  description: 'Organic frozen blueberries 5lb',  qty: 420, weightLbs: 2100, pallets: 3, lot: 'L2603A' },
    { sku: 'RNF-FB-RS',  description: 'Organic frozen raspberries 5lb',  qty: 300, weightLbs: 1500, pallets: 2, lot: 'L2603B' },
    { sku: 'RNF-FB-ST',  description: 'Organic frozen strawberries 5lb', qty: 360, weightLbs: 1800, pallets: 3, lot: 'L2603C' },
    { sku: 'RNF-FB-BK',  description: 'Organic frozen blackberries 5lb', qty: 240, weightLbs: 1200, pallets: 2, lot: 'L2603D' },
    { sku: 'RNF-FB-MX',  description: 'Mixed berry blend 10lb',          qty: 280, weightLbs: 2800, pallets: 3, lot: 'L2603E' },
    { sku: 'RNF-FB-AC',  description: 'Acai puree 5lb',                  qty: 120, weightLbs: 600,  pallets: 1, lot: 'L2603F' },
    { sku: 'RNF-FB-MN',  description: 'Mango chunks 5lb',                qty: 180, weightLbs: 900,  pallets: 2, lot: 'L2603G' },
    { sku: 'RNF-FB-PK',  description: 'Frozen berry sample pack',         qty: 80,  weightLbs: 640,  pallets: 1, lot: 'L2603H' },
    { sku: 'RNF-PAL',    description: 'Export-grade pallets + liners',    qty: 20,  weightLbs: 400,  pallets: 2, lot: 'L2603I' },
    { sku: 'RNF-ICE',    description: 'Dry ice packs (CARM approved)',    qty: 40,  weightLbs: 160,  pallets: 1, lot: 'L2603J' },
  ]),
];

function seedPicksFor(loadId, rows) {
  return rows.map((r, i) => ({
    id: `${loadId}-pick-${String(i + 1).padStart(2, '0')}`,
    loadId,
    pickNumber: i + 1,
    pickedAt: NOW,
    ...r,
  }));
}
